module.exports = __webpack_public_path__ + "static/media/constructive-criticism.2b411c5b.svg";